import { createFileRoute } from '@tanstack/react-router';

import { AssessmentTemplatesPage } from '@/features/admin/AssessmentTemplatesPage';

export const Route = createFileRoute('/_authed/admin/assessments/')({
  component: AssessmentTemplatesPage,
});
